import React, { useState, useEffect, Fragment } from 'react';
const HeroImage = '/images/updated.png';
const Logo = '/images/logo-48.png';
const Logo2x = '/images/logo-192.png';
const Money = '/images/icons/Money.svg';
const Approval = '/images/icons/Approval.svg';
const Trust = '/images/icons/Trust.svg';
const Hand = '/images/icons/Hand.svg';
const Experian = '/images/icons/Experian.svg';
const Call = '/images/icons/call.svg';
const Mail = '/images/icons/mail.svg';
import { Registration, Modal } from '@fincity-frontend/shared-ui';
import Login from '../../containers/Employee/Login/Login';
import { rightDivision } from './LandingPage.module.css';
const footerItems = [
  {
    logo: {
      src: Money,
      alt: 'Money'
    },
    caption: '1 Application - > 50 + Lenders'
  },
  {
    logo: {
      src: Approval,
      alt: 'Approval'
    },
    caption: 'Instant Approval'
  },
  {
    logo: {
      src: Trust,
      alt: 'Trust'
    },
    caption: 'Trusted by 1,00,000+ Customers'
  },
  {
    logo: {
      src: Hand,
      alt: 'Hand'
    },
    caption: '500 + Cr disbursed'
  },
  {
    logo: {
      src: Experian,
      alt: 'Experian',
      className: 'h-8'
    }
  }
];
function LandingPage({ btn, setbtn }) {
  const [show, setShow] = useState(false);

  const popVid = () => {
    setShow(true);
  };
  return (
    <div className=" relative flex flex-wrap flex-col md:min-h-screen  items-end ">
      <div className="flex-1 w-full flex flex-wrap flex-col md:flex-row h-auto relative overflow-y-hidden">
        {/* LeftCol */}
        <div className="hidden lg:block w-full lg:w-2/4 pt-24 overflow-y-auto">
          <img className="mx-auto " alt="hero" src={HeroImage} />
          <div className="absolute bottom-0  w-full lg:w-2/4 mb-24">
            <div className="mx-auto table">
              <p className="font-bold text-center -mt-16 text-lg text-grey-600 ">
                NEED HELP? FOR ANY QUERIES CONTACT US AT
              </p>
              <div className="flex items-baseline justify-center mt-5 px-4 mx-auto ">
                <div className="  inline-flex pt-px phNo">
                  <img
                    className="h-4 w-6 mt-2  mr-1"
                    src={Call}
                    alt="Call logo"
                  />
                  <p className=" text-black-300 text-xl ">080-40828400</p>
                </div>
                <div className="ml-8 inline-flex mail">
                  <img
                    className="h-4 w-6 mt-2 mr-1"
                    src={Mail}
                    alt="mail logo"
                  />
                  <p className="text-black-300 text-xl">info@fincity.com</p>
                </div>
              </div>
              {btn == 'bp' && (
                <Fragment>
                  <div
                    className="underline text-center text-green-600 mt-4 cursor-pointer"
                    onClick={popVid}
                  >
                    Trouble signing up?
                  </div>
                  <Modal show={show} setShow={setShow} xl={true}>
                    <iframe
                      width="100%"
                      height="315"
                      src="https://www.youtube.com/embed/Walix33bWr4"
                      frameborder="0"
                      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen
                    ></iframe>
                  </Modal>
                </Fragment>
              )}
            </div>
          </div>
        </div>
        {/* RightCol */}
        <div className="flex flex-col w-full mt-5 lg:w-2/4 px-2 md:px-8 lg:pl-0 lg:pr-5 xl:pr-10 justify-center lg:items-start md:h-screen">
          <div
            id="rightCol"
            className=" flex-1 bg-white h-full  px-2 pt-2 md:px-4 md:pt-4 w-full text-center  overflow-auto"
          >
            <img
              className="block h-16 py-2 mx-auto"
              alt="hero"
              src={Logo}
              srcSet={`${Logo2x} 2x`}
            />
            <div className=" flex-1 py-2 text-black-200">
              Make yourself at home
            </div>

            <div
              className={`flex-1 relative pt-16 pb-2 font-roboto font-bold text-black-100 overflow-auto ${rightDivision}`}
            >
              <div className="relative"> GET STARTED</div>

              <div className="flex-1 pb-2 mt-5 w-full  max-w-xs mx-auto text-left">
                <div className="inline-flex block rounded z-10 border border-orange-500 w-full ">
                  <button
                    type="button"
                    className={
                      (btn === 'rm' ? 'btnActive text-white' : '') +
                      ' block rounded-l p-3 z-0  w-1/2 h-full '
                    }
                    onClick={() => {
                      setbtn('rm');
                    }}
                  >
                    RM
                  </button>
                  <button
                    type="button"
                    className={
                      (btn === 'bp' ? 'btnActive text-white' : '') +
                      ' block rounded-r p-3 z-0 w-1/2 h-full '
                    }
                    onClick={() => {
                      setbtn('bp');
                    }}
                  >
                    Business Partner
                  </button>
                </div>
                {btn == 'rm' && <Login />}
                {btn == 'bp' && <Registration />}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer */}
      <div className="flex-initial flex flex-col md:absolute md:inset-x-0 md:bottom-0 md:flex-row items-center justify-around w-full py-4 px-2 text-sm text-center md:text-left bg-teal">
        {footerItems.map(({ logo, caption }) => (
          <div
            key={logo.src + logo.alt}
            className={`flex flex-row justify-center items-center my-2 md:my-0${
              caption ? ' mx-2' : ' mx-2'
            }`}
          >
            <img
              className={`pr-2${logo.className ? logo.className : ' w-8'}`}
              src={logo.src}
              alt={logo.alt}
            />
            {caption && (
              <p className="text-base md:text-sm text-left text-white">
                {caption}
              </p>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
export default LandingPage;
